import React from 'react';
import { styled } from 'styled-components';
import { SSpanTitle } from '~/components/styles/styles';
import bgHeader from '@assets/images/background/bg-header-list.png';
import iconClose from '@assets/images/icon/icon-close.svg';
import { classic } from '~/themes';

type IProps = {
  children: React.ReactNode;
  title?: string;
  widthPortrait?: string;
  widthLandscape?: string;
  headerChildren?: React.ReactNode;
  footerChildren?: React.ReactNode;
  onClose?: () => void;
  titleWithoutBorder?: boolean;
};

type TProps = IProps;

export function WrapperListAuto({
  children,
  title,
  headerChildren,
  footerChildren,
  onClose,
  titleWithoutBorder,
}: TProps) {
  return (
    <Container>
      <SDivHeader>
        <SBgHeaderImg
          $titleWithoutBorder={titleWithoutBorder}
          src={bgHeader}
          alt="bg"
        />
        {onClose && (
          <SCloseBtn onClick={onClose}>
            <SBtnImg src={iconClose} alt="" />
          </SCloseBtn>
        )}

        <SHeaderContent>
          <SSpanTitle $marginBottom="10px" $color={classic.token?.colorWhite}>
            {title}
          </SSpanTitle>
          <SDivHeaderChildren>{headerChildren}</SDivHeaderChildren>
        </SHeaderContent>
      </SDivHeader>
      <SDivContent>{children}</SDivContent>
      {footerChildren && (
        <SDivFooterChildren>{footerChildren}</SDivFooterChildren>
      )}
    </Container>
  );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SDivContent = styled.div`
  height: 100%;
  width: 100%;
`;

const SDivHeaderChildren = styled.div`
  width: 100%;
`;

const SDivFooterChildren = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
`;

const SHeaderContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding-top: 5px;
  z-index: 2;
`;

const SCloseBtn = styled.button`
  background-color: transparent;
  border: none;
  position: absolute;
  cursor: pointer;
  top: 15px;
  right: 15px;
  height: 33px;
  width: 33px;
  outline: none;
  z-index: 3;

  @media screen and (max-width: 450px) {
    top: 10px;
    right: 10px;
    height: 24px;
    width: 24px;
  }

  @media screen and (max-height: 450px) {
    top: 10px;
    right: 10px;
    height: 24px;
    width: 24px;
  }

  &:focus {
    outline: none;
  }
  &:hover {
    outline: none;
  }
`;

const SBtnImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
  height: 100%;
  width: 100%;
`;

const SDivHeader = styled.div<{ $background?: string }>`
  align-items: center;
  display: flex;
  background: ${({ $background }) =>
    $background ? `url('${$background}') bottom/cover no-repeat` : 'none'};
  position: relative;
  padding: 20px 20px 0 20px;
  width: 100%;
`;

const SBgHeaderImg = styled.img<{ $titleWithoutBorder?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  object-fit: ${({ $titleWithoutBorder }) =>
    $titleWithoutBorder ? 'cover' : 'fill'};
  height: 100%;
  width: 100%;
`;
